var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',_vm._b({attrs:{"props":_vm.props,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}},'el-cascader',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }